import React, { useContext } from "react";

// Global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

// Material UI stuff
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";

import clsx from "clsx";
const OpenDrawerButton = ({ classes }) => {
  // Consuming state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  //   open drawer
  const handleDrawerOpen = () => {
    setState({ ...state, isSidebarOpen: true });
  };

  return (
    <div>
      <IconButton
        aria-label="state.isSidebarOpen drawer"
        onClick={handleDrawerOpen}
        edge="start"
        className={clsx(classes.menuButton, {
          [classes.hide]: state.isSidebarOpen,
        })}
      >
        <MenuIcon
          style={{
            color: state.theme === "light" ? "#ffffff" : "#fa0171",
            margin: "4.5px 0 5.5px 16px",
            fontSize: "30px",
          }}
        />
      </IconButton>
    </div>
  );
};

export default OpenDrawerButton;
